import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { InitialData } from 'app/app.types';
import { AuthService } from './core/auth/auth.service';
import { webpages_Role } from './shared/models/domain/data.model';
import { environment } from 'environments/environment';
import { CamelCaseToWordsPipe } from './shared/pipes/camel-case-to-words.pipe';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver 
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient
        , private authService: AuthService
        , private camelPipe: CamelCaseToWordsPipe) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            this._httpClient.get<any>('api/common/messages'),
            this._httpClient.get<any>('api/common/navigation'),
            this._httpClient.get<any>('api/common/notifications'),
            this._httpClient.get<any>('api/common/shortcuts'),
            this._httpClient.get<any>('api/common/user')
        ]).pipe(
            map(([messages, navigation, notifications, shortcuts, user]) => {

                const tabs = [];
                let horizontal = navigation.horizontal;
                let compact = navigation.compact;

                if (this.authService.localUserRoles
                    && this.authService.localUserRoles.length) {

                    this.authService.localUserRoles
                        .forEach((role: webpages_Role) => {
                            Object.keys(environment.roleTabs)
                                .forEach((key) => {
                                    if (environment.roleTabs[key].includes(role.roleName)
                                        && !tabs.includes(key)) {
                                        tabs.push({ key: key, label: this.camelPipe.transform(key) });
                                    }
                                });
                        });

                    const keys = tabs.map(t => t.key);
                    if (keys && keys.length) {
                        if (keys.includes('admin')) {
                            horizontal = navigation.admin
                            compact = navigation.adminCompact;
                        } else if (keys.includes('customer')) {
                            horizontal = navigation.customer;
                        } else if (keys.includes('auditor')) {
                            horizontal = navigation.auditor;
                        } else if (keys.includes('salesRep')) {
                            horizontal = navigation.salesRep;
                        } else {
                          horizontal = navigation.default;
                        }
                    } else {
                      horizontal = navigation.default;
                    }
                } else {
                    horizontal = navigation.default;
                }

                return {
                    messages,
                    navigation: {
                        compact: compact,
                        default: navigation.default,
                        futuristic: navigation.futuristic,
                        horizontal: horizontal
                    },
                    notifications,
                    shortcuts,
                    user
                };
            })
        );
    }
}
